import { render } from "./UpdateStaff.vue?vue&type=template&id=61779e82"
import script from "./UpdateStaff.vue?vue&type=script&lang=js"
export * from "./UpdateStaff.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/Projects/inqi/inqi-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__